import React from 'react'
import { IInputTextProps } from './InputComponent.types'

import { Input } from './styles'

const InputText: React.FC<IInputTextProps> = ({ ...props }) => {
  return <Input {...props} />
}

export default InputText
